import "core-js/modules/es6.function.name";
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  name: 'roseChart',
  props: ['chart'],
  methods: {
    initRoseChart: function initRoseChart(data, dataText) {
      var scaleData = data;
      var placeHolderStyle = {
        normal: {
          label: {
            show: false
          },
          labelLine: {
            show: false
          },
          color: 'rgba(0, 0, 0, 0)',
          borderColor: 'rgba(0, 0, 0, 0)',
          borderWidth: 0
        }
      };
      var data = [];
      var color = ['rgb(255, 153, 153)', 'rgb(255, 176, 63)', 'rgb(61, 186, 45)', 'rgb(43, 166, 254)'];
      var colorBorder = ['rgba(255, 153, 153, 0.4)', 'rgba(255, 176, 63, 0.4)', 'rgba(61, 186, 45, 0.4)', 'rgba(43, 166, 254, 0.4)'];

      for (var i = 0; i < scaleData.length; i++) {
        data.push({
          data: scaleData[i].value,
          value: 20,
          name: scaleData[i].name,
          itemStyle: {
            normal: {
              color: color[i],
              borderWidth: 20,
              borderColor: colorBorder[i]
            }
          }
        }, {
          value: 8,
          name: '',
          itemStyle: placeHolderStyle
        });
      }

      data.push({
        value: 40,
        name: '',
        itemStyle: placeHolderStyle
      });
      var seriesObj = [{
        name: '',
        type: 'pie',
        clockWise: false,
        radius: [70, 120],
        hoverAnimation: false,
        startAngle: -35,
        itemStyle: {
          normal: {
            label: {
              show: true,
              position: 'inner',
              fontSize: 14,
              lineHeight: 15,
              formatter: function formatter(params) {
                var percent = 0;
                var total = 0;

                for (var i = 0; i < scaleData.length; i++) {
                  total += scaleData[i].value;
                }

                percent = (params.value / total * 100).toFixed(0);

                if (params.name !== '') {
                  // return params.name + '\n' + params.data.data;
                  if (params.name.length > 4) {
                    return params.name.slice(0, 3) + '\n' + params.name.slice(3);
                  } else {
                    return params.name;
                  }
                } else {
                  return '';
                }
              }
            },
            labelLine: {
              length: 10,
              length2: 20,
              show: true
            }
          }
        },
        data: data
      }, {
        name: '',
        type: 'pie',
        clockWise: false,
        radius: [70, 120],
        hoverAnimation: false,
        startAngle: -30,
        itemStyle: {
          normal: {
            label: {
              show: true,
              position: 'outside',
              fontSize: 18,
              formatter: function formatter(params) {
                var percent = 0;
                var total = 0;

                for (var i = 0; i < scaleData.length; i++) {
                  total += scaleData[i].value;
                }

                percent = (params.value / total * 100).toFixed(0);

                if (params.name !== '') {
                  return params.data.data;
                } else {
                  return '';
                }
              }
            },
            labelLine: {
              length: 10,
              length2: 20,
              show: true
            }
          }
        },
        data: data
      }];
      var option = {
        backgroundColor: 'transparent',
        tooltip: {
          show: false
        },
        legend: {
          show: false
        },
        toolbox: {
          show: false
        },
        // grid: {
        //   left:"40%",
        //   top:"40%"
        // },
        series: seriesObj,
        graphic: [{
          type: 'group',
          left: 'center',
          top: 'middle',
          children: [{
            type: 'text',
            z: 100,
            left: 'center',
            top: '0',
            style: {
              fill: '#006837',
              text: ['联网率'],
              font: '16px Microsoft YaHei'
            }
          }, {
            type: 'text',
            z: 100,
            left: 'center',
            top: '32',
            style: {
              fill: 'red',
              text: [dataText],
              font: '20px Microsoft YaHei'
            }
          }]
        }]
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart); //获取圆上面某点的坐标(x0,y0表示坐标，r半径，angle角度)
      // function getCirlPoint(x0, y0, r, angle) {
      //   let x1 = x0 + r * Math.cos((angle * Math.PI) / 180)
      //   let y1 = y0 + r * Math.sin((angle * Math.PI) / 180)
      //   return {
      //     x: x1,
      //     y: y1
      //   }
      // }

      myChart.setOption(option);

      window.onresize = function () {
        myChart.resize();
      };
    }
  }
};